export default "__VITE_ASSET__B7kgA7NR__"